<template>
  <div class="__C_Badge">
    <q-badge :outline="outline" :align="align" :color="colorNameFormatter(color)">
      <slot />
    </q-badge>
  </div>
</template>

<script>
/**
 * Using quasar Badge.
 * https://quasar.dev/vue-components/badge
 *
 * color: {string} - primary, secondary, accent, dark, success, danger, info, warning
 * align: {string} - top, middle, bottom
 * outline: {boolean}
 */

import Vue from 'vue';
import { colorNameFormatter } from '@/components/uikit/lib';

export default Vue.extend({
  name: 'CBadge',
  props: {
    color: { type: String, default: 'primary' },
    align: { type: String, default: 'middle' },
    outline: { type: Boolean },
  },
  methods: {
    colorNameFormatter(type) {
      return colorNameFormatter(type);
    },
  },
});
</script>

<style lang="scss" scoped>
.q-badge::v-deep {
  //  font-size: $font-size-sm;
}
.__C_Badge {
  display: inline-block;
}
</style>
